import PreguntasConfirmacionListLayer from "../../components/PreguntasConfirmacionListLayer";

const PreguntasConfirmacionPage = () => {
  return <PreguntasConfirmacionListLayer />;
};

export default PreguntasConfirmacionPage;
